import axios from 'axios';
import { baseURL, generalEndpoint } from '../config';

const API_BASE_URL = process.env.REACT_APP_API_URL || baseURL + '/' + generalEndpoint;

/**
 * Get all executions
 * @param {string} token - Authentication token
 * @returns {Promise<Array>} The API response
 */
export const getAllExecutions = async (token) => {
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    try {
        console.log('API Request - URL:', `${API_BASE_URL}/Execution`);
        const response = await axios.get(
            `${API_BASE_URL}/Execution`,
            config
        );
        
        console.log('API Response - All Executions:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching all executions:', error);
        throw error.response?.data || error.message;
    }
};

/**
 * Get filled executions
 * @param {string} token - Authentication token
 * @returns {Promise<Array>} The API response
 */
export const getFilledExecutions = async (token) => {
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    try {
        console.log('API Request - URL:', `${API_BASE_URL}/Execution/Filled`);
        const response = await axios.get(
            `${API_BASE_URL}/Execution/Filled`,
            config
        );
        
        console.log('API Response - Filled Executions:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching filled executions:', error);
        throw error.response?.data || error.message;
    }
};

/**
 * Get cancelled executions
 * @param {string} token - Authentication token
 * @returns {Promise<Array>} The API response
 */
export const getCancelledExecutions = async (token) => {
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    try {
        console.log('API Request - URL:', `${API_BASE_URL}/Execution/Cancelled`);
        const response = await axios.get(
            `${API_BASE_URL}/Execution/Cancelled`,
            config
        );
        
        console.log('API Response - Cancelled Executions:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching cancelled executions:', error);
        throw error.response?.data || error.message;
    }
};

/**
 * Get rejected executions
 * @param {string} token - Authentication token
 * @returns {Promise<Array>} The API response
 */
export const getRejectedExecutions = async (token) => {
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    try {
        console.log('API Request - URL:', `${API_BASE_URL}/Execution/Rejected`);
        const response = await axios.get(
            `${API_BASE_URL}/Execution/Rejected`,
            config
        );
        
        console.log('API Response - Rejected Executions:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching rejected executions:', error);
        throw error.response?.data || error.message;
    }
};
